module.exports = __webpack_public_path__ + "static/media/tablet-hero-image.f21c42c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tablet-hero-image.svg
// module id = 42
// module chunks = 0